import React from 'react';
import HeaderTransparente from './components/HeaderTransparente';
import HeaderBranco from './components/HeaderBranco';
import MainSection from './components/MainSection';
import MainSectionBranco from './components/MainSectionBranco';
import SectionSobre from './components/SectionSobre';
import GaleriaFotos from './components/GaleriaFotos';
import Programacao from "./components/Programacao";
import ProgramacaoBranco from './components/ProgramacaoBranco';
import Local from "./components/Local";
import LocalBranco from './components/LocalBranco';
import GarantaSuaVaga from "./components/GarantaSuaVaga";
import IngressoPage from './components/IngressoPage';
import Footer from './components/Footer';
import FooterInova from './components/FooterInova';
import FooterTransparente from './components/FooterTransparente';
import SectionServicos from './components/SectionServicos';
import SectionGaleria from './components/SectionGaleria';
import BotaoSubir from './components/BotaoSubir';
import WhatsAppButton from './components/WhatsAppButton';
import Portifolio from './components/Portifolio';
import Tecnologias from './components/Tecnologias';
import Funcionalidades from './components/Funcionalidades';

function App() {
  return (
    <div>
      <HeaderBranco />
      <MainSectionBranco />
      <GaleriaFotos />
      <ProgramacaoBranco />
      <Tecnologias />
      <Portifolio />
      <Funcionalidades />
      <BotaoSubir />
      <WhatsAppButton />
      <FooterInova />
    </div>
  );/*
  return (
    <div>
      <HeaderTransparente />
      <MainSection />
      <Footer />
    </div>
  );*/
  /*return (
    <div>
      <HeaderTransparente />
      <SectionSobre />
      <SectionServicos />
      <Programacao />
      <SectionGaleria />
      <Local />
      <GarantaSuaVaga />
      <FooterTransparente />
      <BotaoSubir />
      <WhatsAppButton />
    </div>
  );*/
}

export default App;
